import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../../constants/colors.constants';

export const commonFlowStyles = () => ({
	root: {
		color: Colors.white,
		minHeight: '100vh',
		background: Colors.black,
		overflow: 'hidden',
	},
	content: {
		position: 'relative',
		zIndex: 1,
	},
	header: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		zIndex: 5,
		background: Colors['11141299'],
		py: '18px',
		pl: { xs: '34px', md: '54px' },
		pr: { xs: '20px', md: '54px' },
		borderBottom: `2px solid ${Colors['120E0D']}`,
		display: 'flex',
		alignItems: 'center',
		// button plus vertical paddings
		minHeight: 'calc(34px + 18px * 2)',
	},
	headerBackButton: {
		position: 'absolute',
		// same as paddings
		top: '50%',
		left: { xs: '34px', md: '54px' },
		transform: 'translateY(-50%)',

		width: '34px',
		height: '34px',
		color: Colors.white,
		border: `1px solid ${Colors['white_a30']}`,
		cursor: 'pointer',
	},
	headerContent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		flex: 1,
		marginLeft: {
			xs: 'calc(34px + 24px)',
			md: 'calc(34px + 24px)',
		},
	},
	body: {
		margin: '0 auto',
		paddingTop: '45px',
		display: 'flex',
		flexDirection: { xs: 'column', md: 'row' },
		columnGap: '50px',
		rowGap: '24px',
		justifyContent: { xs: 'flex-start', md: 'space-between' },
		alignItems: { xs: 'center', md: 'unset' },
		maxWidth: '1240px',
	},
	footer: {
		position: { xs: 'static', md: 'fixed' },
		bottom: 0,
		left: 0,
		right: 0,
		background: Colors.black,
		py: '12px',
		px: '24px',
		borderTop: `1px solid ${Colors['white_a30']}`,
	},
	footerContent: {
		margin: '0 auto',
		display: 'flex',
		flexDirection: { xs: 'column', sm: 'row' },
		alignItems: 'center',
		gap: '12px',
		maxWidth: '1240px',
	},
	submitButton: {
		minWidth: { xs: '100%', sm: '200px', lg: '300px' },
		minHeight: '42px',
		padding: '12px 32px',
	},
});

export const editCommunityFlowStyles = () => ({
	section1: {
		flex: 1,
		px: '24px',
		mb: '100px',
		overflow: 'hidden',
		maxWidth: '490px',
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
		width: { xs: '100%', sm: 'auto' },
	},
	avatarBox: {
		p: '12px',
		display: 'flex',
		justifyContent: 'center',
	},
	photosSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},
	photosLabel: {
		fontFamily: 'Integral CF, sans-serif',
		fontWeight: '700',
		fontSize: '15px',
		lineHeight: '18px',
	},
	photosBox: {
		display: 'flex',
		flexFlow: 'row nowrap',
		columnGap: '8px',
		rowGap: '10px',
		maxWidth: 'fit-content',
		overflowX: 'auto',
		paddingBottom: '4px',

		'&::-webkit-scrollbar': {
			width: '4px',
			height: '4px',
		},

		'&::-webkit-scrollbar-thumb': {
			borderRadius: '2px',
			backgroundColor: 'rgba(250, 250, 250, 0.7)',
		},
	},
	section2: {
		order: { xs: -1, md: 0 },
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: '16px',
		px: { xs: '0', sm: '16px' },
	},
	backgroundBox: (src?: string) => ({
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		py: { xs: '21px', md: '38px' },
		px: '22px',
		aspectRatio: '432/540',
		maxWidth: '432px',
		width: { xs: '100%', sm: 'auto' },
		border: src ? 'none' : `0.63px dashed ${Colors['3A3A3A']}`,
		background: src ? `url(${src}) no-repeat center center` : Colors['1A1A1A'],
		backgroundSize: src ? `cover` : 'auto',
		borderRadius: '3px',
	}),
	backgroundInput: {
		minWidth: { xs: '260px', sm: '320px', md: '360px', lg: '389px' },
		aspectRatio: '389/486',
		background: Colors['141414'],
		borderRadius: '10px',
		maxWidth: { xs: 'none' },
		width: { xs: '100%' },
	},
	hostColorBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},
	hostColorLabel: {
		fontFamily: 'Montserrat, sans-serif',
		fontWeight: '600',
		fontSize: '15px',
		lineHeight: '21px',
		textAlign: 'center',
	},
});
